import Gem from './gem';
import Metal from './metal';
import ChainType from './chainType';
import ChainLength from './chainLength';
import RingSize from './ringSize';
import Image from './image';

class Variation {
  constructor(
    {
      id,
      attributes: {
        sku,
        wholesale_price,
        retail_price,
        image,
        createdAt,
        updatedAt,
        publishedAt,
        gem,
        metal,
        chain_type,
        chain_length,
        ring_sizes,
      },
    },
    jewelryType,
  ) {
    this.id = id;
    this.sku = sku;
    this.wholesalePrice = wholesale_price;
    this.retailPrice = retail_price;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.publishedAt = publishedAt;

    if (gem?.data) {
      this.gem = new Gem(gem.data);
    }
    if (metal?.data) {
      this.metal = new Metal(metal.data);
    }
    if (chain_type?.data) {
      this.chainType = new ChainType(chain_type.data);
    }
    if (chain_length?.data) {
      this.chainLength = new ChainLength(chain_length.data);
    }
    if (ring_sizes?.data) {
      this.ringSizes = ring_sizes.data.map((size) => new RingSize(size));
    }
    if (image?.data) {
      this.image = new Image(image.data);
    }

    this.description = this.generateDescription(
      jewelryType,
      this.gem,
      this.metal,
      this.chainType,
      this.chainLength,
    );
  }

  generateDescription(jewelryType, gem, metal, chainType, chainLength) {
    let desc = [];
    desc.push(
      jewelryType?.title,
      gem?.title,
      metal?.title,
      chainType?.title,
      chainLength?.length,
    );
    desc = desc.filter((n) => n);
    return desc.map((d) => d).join(' / ');
  }
}

export default Variation;
